{
  "name": "@bjia56/portable-python",
  "version": "0.1.164",
  "description": "Portable Python",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "prebuild": "rimraf README.md && rimraf dist",
    "build": "cp ../../README.md . && tsc --outDir dist",
    "prepublishOnly": "npm run build",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/bjia56/portable-python.git"
  },
  "keywords": [
    "python"
  ],
  "author": "Brett Jia",
  "license": "Apache-2.0",
  "bugs": {
    "url": "https://github.com/bjia56/portable-python/issues"
  },
  "homepage": "https://github.com/bjia56/portable-python",
  "dependencies": {
    "adm-zip": "^0.5.10"
  },
  "devDependencies": {
    "@types/adm-zip": "^0.5.5",
    "rimraf": "^5.0.5",
    "ts-node": "^10.9.1",
    "typescript": "^5.3.2"
  },
  "portablePython": {
    "cpython": {
      "versions": [
        "3.13.9",
        "3.13.8",
        "3.13.7",
        "3.13.6",
        "3.13.5",
        "3.13.4",
        "3.13.3",
        "3.13.2",
        "3.13.1",
        "3.13.0",
        "3.12.12",
        "3.12.11",
        "3.12.10",
        "3.12.9",
        "3.12.8",
        "3.12.7",
        "3.12.6",
        "3.11.14",
        "3.11.13",
        "3.11.12",
        "3.11.11",
        "3.11.10",
        "3.11.9",
        "3.10.19",
        "3.10.18",
        "3.10.17",
        "3.10.16",
        "3.10.15",
        "3.10.14",
        "3.9.24",
        "3.9.23",
        "3.9.22",
        "3.9.21",
        "3.9.20",
        "3.9.19"
      ],
      "versionBuilds": {
        "3.9.19": "cpython-v3.9.19-build.6",
        "3.10.14": "cpython-v3.10.14-build.6",
        "3.11.9": "cpython-v3.11.9-build.6",
        "3.9.20": "cpython-v3.9.20-build.1",
        "3.10.15": "cpython-v3.10.15-build.1",
        "3.11.10": "cpython-v3.11.10-build.2",
        "3.12.6": "cpython-v3.12.6-build.5",
        "3.12.7": "cpython-v3.12.7-build.1",
        "3.13.0": "cpython-v3.13.0-build.0",
        "3.9.21": "cpython-v3.9.21-build.0",
        "3.10.16": "cpython-v3.10.16-build.0",
        "3.11.11": "cpython-v3.11.11-build.0",
        "3.12.8": "cpython-v3.12.8-build.0",
        "3.13.1": "cpython-v3.13.1-build.3",
        "3.9.22": "cpython-v3.9.22-build.2",
        "3.10.17": "cpython-v3.10.17-build.2",
        "3.11.12": "cpython-v3.11.12-build.2",
        "3.12.9": "cpython-v3.12.9-build.0",
        "3.12.10": "cpython-v3.12.10-build.2",
        "3.13.2": "cpython-v3.13.2-build.0",
        "3.13.3": "cpython-v3.13.3-build.2",
        "3.9.23": "cpython-v3.9.23-build.2",
        "3.10.18": "cpython-v3.10.18-build.2",
        "3.11.13": "cpython-v3.11.13-build.2",
        "3.12.11": "cpython-v3.12.11-build.2",
        "3.13.4": "cpython-v3.13.4-build.1",
        "3.13.5": "cpython-v3.13.5-build.1",
        "3.13.6": "cpython-v3.13.6-build.0",
        "3.13.7": "cpython-v3.13.7-build.0",
        "3.9.24": "cpython-v3.9.24-build.0",
        "3.10.19": "cpython-v3.10.19-build.0",
        "3.11.14": "cpython-v3.11.14-build.0",
        "3.12.12": "cpython-v3.12.12-build.0",
        "3.13.8": "cpython-v3.13.8-build.0",
        "3.13.9": "cpython-v3.13.9-build.0"
      }
    },
    "graalpy": {
      "versions": [
        "25.0.0",
        "24.2.2",
        "24.2.1",
        "24.2.0",
        "24.1.2",
        "24.1.1",
        "24.1.0",
        "24.0.2"
      ],
      "versionBuilds": {
        "24.0.2": "graalpy-v24.0.2-build.0",
        "24.1.0": "graalpy-v24.1.0-build.0",
        "24.1.1": "graalpy-v24.1.1-build.0",
        "24.1.2": "graalpy-v24.1.2-build.0",
        "24.2.0": "graalpy-v24.2.0-build.0",
        "24.2.1": "graalpy-v24.2.1-build.0",
        "24.2.2": "graalpy-v24.2.2-build.0",
        "25.0.0": "graalpy-v25.0.0-build.0"
      }
    },
    "pypy": {
      "versions": [
        "7.3.20",
        "7.3.19",
        "7.3.18",
        "7.3.17",
        "7.3.16"
      ],
      "versionBuilds": {
        "7.3.16": "pypy-v7.3.16-build.0",
        "7.3.17": "pypy-v7.3.17-build.0",
        "7.3.18": "pypy-v7.3.18-build.0",
        "7.3.19": "pypy-v7.3.19-build.0",
        "7.3.20": "pypy-v7.3.20-build.0"
      }
    }
  }
}